import { currentAccountResourceTypesHierarchySelector } from "./currentAccountResourceTypesHierarchySelector";
import { RootState } from "../../../store";
import { ResourceType } from "../../../../services/cloudchipr.api";

export const currentAccountSelectedRowsWithHierarchyByResourceTypeSelector = (
  state: RootState,
  resourceType?: ResourceType,
): Record<ResourceType, Record<string, boolean>> | undefined => {
  if (!resourceType) {
    return;
  }

  const resourceTypesHierarchy = currentAccountResourceTypesHierarchySelector(
    state,
    resourceType,
  );

  return resourceTypesHierarchy.reduce(
    (result, item) => {
      const data = Object.values(state.account.selected[item] ?? {});

      const values = Object.values(data);
      values.forEach((member) => {
        if (!Object.keys(member).length) {
          return;
        }
        const data = result?.[item]
          ? { ...result[item], ...member }
          : { ...member };
        result = {
          ...result,
          [item]: {
            ...data,
          },
        };
      });

      return result;
    },
    {} as Record<ResourceType, Record<string, boolean>>,
  );
};
